class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.delay = Number(this.dataset.delay) * 1000;
    this.version = this.dataset.version;
    this.closedVersion = localStorage.getItem("promo_closed_version");

    const overlayId = this.id.replace("PromoPopup", "PromoOverlay");
    const closeId = this.id.replace("PromoPopup", "PromoClose");
    this.overlay = document.getElementById(overlayId);
    this.closeBtn = document.getElementById(closeId);
  }

  connectedCallback() {
    // If the user has already closed THIS campaign version → don't show again
    if (this.closedVersion === this.version) {
      return;
    }

    // Show popup after delay
    setTimeout(() => {
      this.show();
    }, this.delay);

    // Close events (X and overlay)
    this.closeBtn?.addEventListener("click", () => this.hide());
    this.overlay?.addEventListener("click", () => this.hide());

    // Close when clicking the popup button (promo-close)
    this.querySelectorAll(".promo-close").forEach(btn => {
      btn.addEventListener("click", () => {
        // Let the browser navigate first — then hide popup after 50ms
        setTimeout(() => this.hide(), 50);
      });
    });
  }

  show() {
    this.querySelector(".promo-popup__wrapper").style.display = "block";
    this.overlay.style.display = "block";
  }

  hide() {
    this.querySelector(".promo-popup__wrapper").style.display = "none";
    this.overlay.style.display = "none";

    // Save version so this campaign won't show again
    localStorage.setItem("promo_closed_version", this.version);
  }
}

customElements.define("promo-popup", PromoPopup);